<template>
    <div class="checkbox" v-disabled="disabled">
        <icon class="checkbox-icon" :name="checked ? 'check' : ''" @click="handleClick"/>
        <span class="checkbox-label" @click="handleClick" v-if="label || $slots.default || $scopedSlots.default">
            <slot><span v-html="label"/></slot>
        </span>
    </div>
</template>

<script>
    import {matchesSelector} from '../helper';

    export default {
        props: {
            value: [Boolean, Array, String, Number],
            name: [String, Number],
            label: {type: String, default: ''},
            disabled: {type: Boolean, default: false},
        },

        computed: {
            checked() {
                if (this.value instanceof Array) {
                    return this.value.includes(this.name);
                }
                if (typeof this.value === "string") {
                    return this.value === "1";
                }
                return !!this.value;
            },

            localValue: {
                get() {
                    return typeof this.value === "string" ? this.value === "1" : this.value;
                },
                set(value) {
                    if (this.value instanceof Array) {
                        value = this.value.slice(0);
                        let index = value.indexOf(this.name);
                        if (~index) {
                            value.splice(index, 1);
                        } else {
                            value.push(this.name);
                        }
                    } else if (typeof this.value === "string") {
                        value = +value + ""; // first bool to int than int to string
                    }
                    this.$emit('input',  value);
                },
            },
        },

        methods: {
            handleClick(event) {
                if (!matchesSelector(event.target, '.prevent, .prevent *')) {
                    this.localValue = !this.localValue;
                }
            },
        },
    };
</script>